import { titles, type Title, type MediaType } from "@/mocks/titles";

export const ITEMS_PER_PAGE = 20;

export const ALL = "全部";

export const REGION_OPTIONS = [
  ALL,
  "中国大陆",
  "中国香港",
  "中国台湾",
  "美国",
  "韩国",
  "日本",
  "英国",
];

export const YEAR_OPTIONS = [ALL, "2025", "2024", "2023", "2022", "2021", "2020"];

export const GENRE_OPTIONS = [
  ALL,
  "剧情",
  "悬疑",
  "惊悚",
  "犯罪",
  "古装",
  "家庭",
  "动作",
  "战争",
  "爱情",
  "科幻",
  "武侠",
  "仙侠",
  "冒险",
  "奇幻",
  "历史",
  "都市",
  "情感",
  "青春",
  "心理",
  "美食",
  "治愈",
  "年代",
  "励志",
  "农村",
  "公路",
];

export const SORT_OPTIONS: { key: SortKey; label: string }[] = [
  { key: "latest", label: "最新上线" },
  { key: "hottest", label: "最多播放" },
  { key: "rating", label: "评分最高" },
];

export type SortKey = "latest" | "hottest" | "rating";

export interface FilterState {
  region: string;
  year: string;
  genre: string;
}

export const defaultFilter: FilterState = {
  region: ALL,
  year: ALL,
  genre: ALL,
};

export interface QueryParams {
  type?: MediaType;
  keyword?: string;
  filter?: FilterState;
  sort?: SortKey;
}

export function queryTitles({ type, keyword, filter, sort = "latest" }: QueryParams): Title[] {
  const word = (keyword || "").trim().toLowerCase();
  const active = filter || defaultFilter;

  const result = titles.filter((item) => {
    if (type && item.type !== type) return false;

    if (word) {
      const haystack = [
        item.title,
        item.summary,
        item.director,
        item.region,
        ...item.cast,
        ...item.genres,
      ]
        .join(" ")
        .toLowerCase();
      if (!haystack.includes(word)) return false;
    }

    if (active.region !== ALL && item.region !== active.region) return false;
    if (active.year !== ALL && String(item.year) !== active.year) return false;
    if (active.genre !== ALL && !item.genres.includes(active.genre)) return false;

    return true;
  });

  return result.sort((a, b) => {
    if (sort === "hottest") return b.heat - a.heat;
    if (sort === "rating") return b.rating - a.rating;
    return b.year - a.year || b.heat - a.heat;
  });
}

export function getRelated(current: Title, count = 6): Title[] {
  const scored = titles
    .filter((item) => item.id !== current.id)
    .map((item) => {
      let score = 0;
      if (item.type === current.type) score += 3;
      score += item.genres.filter((genre) => current.genres.includes(genre)).length * 4;
      if (item.region === current.region) score += 2;
      if (item.director === current.director) score += 2;
      return { item, score };
    })
    .sort((a, b) => b.score - a.score || b.item.rating - a.item.rating);

  return scored.slice(0, count).map((entry) => entry.item);
}

export function getLatest(type: MediaType, count = 12): Title[] {
  return queryTitles({ type, sort: "latest" }).slice(0, count);
}

export function getHot(count = 12): Title[] {
  return queryTitles({ sort: "hottest" }).slice(0, count);
}